import fetchRequest from '../common/fetchRequest';

export default function fetchSuggestions (url, method = 'GET', data = {}) {
    return fetchRequest(url, {
        method,
        data,
        dataType: 'json',
    }).then(result => result).catch(() => []);
}



// WEBPACK FOOTER //
// ./src/scripts/components/search/fetchSuggestions.js